import { render, staticRenderFns } from "./dialog4.vue?vue&type=template&id=6ebf175c&scoped=true"
import script from "./dialog4.vue?vue&type=script&lang=js"
export * from "./dialog4.vue?vue&type=script&lang=js"
import style0 from "./dialog4.vue?vue&type=style&index=0&id=6ebf175c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf175c",
  null
  
)

export default component.exports